import { ALERT_P450 } from './actionsTypes';

export const alertP450 = (alertP450) => {
  return {
    type: ALERT_P450,
    alertP450: alertP450
  };
};
